<template>
  <section>
    <div class="card">
      <div class="by-tag-sales-repartition">
        <p class="card-title"> Ventes par sous-campagne de mon équipe</p>
        <div class="leaderboard-inner">
          <b-loading
            :is-full-page="false"
            :active.sync="isLoading"
            :can-cancel="true"
          ></b-loading>

          <b-select
            placeholder="Choisir le"
            v-model="sortMode"
            @input="sortTags()"
          >
            <option value="0">Aujourd'hui</option>
            <option value="1">Total</option>
          </b-select>

          <ve-pie
            class="graph"
            :data="chartData"
          >
          </ve-pie>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VeHistogram from "v-charts/lib/histogram.common";
import VePie from "v-charts/lib/pie.common";

export default {
  name: "byTagSalesRepartition",
  components: { "ve-histogram": VeHistogram, "ve-pie": VePie },
  props: ["sales", "users", "isAdmin", "campaigns"],

  data: () => {
    return {
      isEmpty: false,
      isLoading: true,
      myData: [],
      avatars: [],
      chartSettings: {
        metrics: ["Total", "Aujourd'hui"]
      },
      chartData: {
        columns: [],
        rows: []
      },
      sortMode: 0
    };
  },
  watch: {
    sales: function(newVal, oldVal) {
      this.sortTags();
      this.isLoading = this.chartData.rows.length == 0;
    }
  },
  methods: {
    getSubCampaignName(fromSubCampaignId) {
      for (var l = 0; l < this.campaigns.length; l++) {
        for (var m = 0; m < this.campaigns[l].sub_campaigns.length; m++) {
          if (fromSubCampaignId == this.campaigns[l].sub_campaigns[m].id) {
            return this.campaigns[l].sub_campaigns[m].name;
          }
        }
      }
    },
    sortTags() {
      var tags = [];
      // 1st retrieve all tags possible
      for (let sale of this.sales) {
        if (sale.sub_campaign_id) tags.push(sale.sub_campaign_id);
      }
      tags = [...new Set(tags)];

      var salesPerTag = [];
      for (var i = 0; i < tags.length; i++) {
        var totalTagSales = [];
        var todaySales = [];
        var days = [];
        for (var j = 0; j < this.sales.length; j++) {
          if (this.sales[j].sub_campaign_id == tags[i]) {
            totalTagSales.push(this.sales[j]);
            if (
              new Date(this.sales[j].creation_date_time) >=
              new Date().setHours(0, 0, 0, 0)
            ) {
              todaySales.push(this.sales[j]);
            }
          }
        }

        salesPerTag.push({
          "Sous-Campagne": this.getSubCampaignName(tags[i]),
          Total: totalTagSales.length, // divide by days
          "Aujourd'hui": todaySales.length
        });

        // HERE WE CHOOSE WHAT TO DISPLAY
        if (this.sortMode == 1) {
          this.chartData.columns = ["Sous-Campagne", "Total"];
        } else {
          this.chartData.columns = ["Sous-Campagne", "Aujourd'hui"];
        }
      }
      this.chartData.rows = salesPerTag;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media screen and (max-width: 768px) {
  .card {
    padding-top: 10px;
    padding-left: 4px;
    padding-right: 4px;
    overflow: hidden;

    .leaderboard-inner {
      margin: 25px 0 0 0;
    }
  }

  .graph {
    margin-top: 10px !important;
  }
}

@media screen and (min-width: 768px) {
  .card {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: none;
    min-width: 1000px;

    .leaderboard-inner {
      margin: 25px 10px;
    }
  }
}
.leaderboard-inner {
  text-align: center;
}

.card {
  box-shadow: none;

  .control {
    text-align: center;
  }
}

body {
  padding-left: 30px;
}

.by-tag-sales-repartition {
  background-color: #2aa3d622;
  border-radius: 10px;
  padding-bottom: 10px;
}

.graph {
  margin-bottom: -60px !important;
}

.loading-overlay {
  padding-right: 20px;
}
</style>